import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import {push as changeURL, replace as replaceURL} from 'react-router-redux';
import EndingPage from '../../EndingPage';

import store from '~/store';
import mapDispatch from '~/misc/mapDispatch';
import {modalChange} from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';
import { getPaymentInfo,payOrderAction} from '~/modules/membership/actions'
import Spinner from '~/components/common/Spinner';
import {track} from '~/misc/metrics';
import {getUrlQeury} from '~/misc/formatUrlquery';
import css from './index.css';
import sharedCSS from '~/components/shared.css';
import accountPageCss from '../../MyAccount/share.css';
import  get  from 'lodash/get';
class OrderPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      orderInfo : {},
      orderStatus: 'pending',
      payedInfo: {},
      payLoading: false ,
    }
  }

  componentWillMount() {
    const { getPaymentInfo } = this.props;
    const orderId = getUrlQeury() ? getUrlQeury().order_id : '';
    const id = getUrlQeury() ? getUrlQeury().userid : '';
    const bussinessCode = getUrlQeury() ? getUrlQeury().bussiness_code : '';
    const token = getUrlQeury() ? getUrlQeury().token : '';
    const source = getUrlQeury() ? getUrlQeury().source : '';
    if (!orderId) {
      this.props.gotoRoot();
    } else {
      this.setState({
        loading: true,
        id,
        orderId,
        bussinessCode,
        source,
      })
      getPaymentInfo({
        id , 
        bussinessCode, 
        orderId, 
        verifyKey: token
      }).then(res=> {
        const orderInfo = res.data.length ? res.data[0] : {}
        const status = orderInfo.status;
        if(status === 'success_paid') {
          return this.setState({
            loading: false,
            payedInfo: orderInfo,
            orderStatus : "successful",
          })
        }
        this.setState({
          loading: false,
          orderInfo 
        })
      })
    }
  }
  
  render() {

    return (
      <div className={cs(sharedCSS.widewrap, 'pay-content')}>
        <div className={cs(sharedCSS.wideStretchable, css.wrap)}>
          <div className={cs(css.content)}>
            { this.renderContent() }
          </div>
        </div>
      </div>
    );
  }

  renderContent() {
    const { loading,orderInfo, id, orderId,orderStatus,error,  bussinessCode ,payedInfo, payLoading, source} = this.state;
    console.log('orderStatus',orderStatus);
    console.log('test',{loading : payLoading,...error });
    const { goToResult } = this.props;
    if (!loading && orderStatus === "pending") {
      return (
        <div>
          <EndingPage
            payInfo={{loading : payLoading,...error }}
            email={orderInfo.billing_info.email}
            user={{id}}
            query={{
              bussinessCode, 
              orderId
            }}
            hide={["address"]}
            orderInfo={orderInfo}
            type='pending'
            from="offcial"
            actionFn={(dispatch, getState, val) => {
              this.setState({
                payLoading: true
              })
              payOrderAction(dispatch, getState, {
                id, bussinessCode, orderId, token: val.token
              }).then( (res)=> {
                const {code,data} = res
                if(code == 100){
                  const error = {
                    error:res.message
                  }
                  this.setState({
                    error
                  })
                }else{
                  this.setState({
                    payLoading: false
                  })
                  const payedInfo = data || {}
                  const paidKey = get(payedInfo, 'product.pay_option.key');
                  const [cycle, type] = paidKey.includes("_") ? paidKey.split("_") : ["", ""]
                  this.setState({
                    orderStatus : "successful",
                    payedInfo
                  }, ()=>{
                    track("buy_successful", {
                      biilling_cycle: cycle,
                      membership: type,
                      source,
                    })
                  })
                }
                
                
              })
            }}
          />
        </div>
      );
    }
    if(!loading && orderStatus === "successful") {
      return (
        <EndingPage user={{id}} hide={["address"]}  orderInfo={payedInfo} type='result'/>
      )
    }
    return (
      <div className={sharedCSS.viewH}>
        <div className={cs(accountPageCss.spinnerLine)}>
          <div className={cs(accountPageCss.spinner, css.marginCenter)}>
            <Spinner scalable={true}/>
          </div>
        </div>
      </div>
    );
  }

}

export default connect(({user, routing, account, hp}) => ({user, routing, account, hp}), mapDispatch({
  login: () => modalChange(modes.LOGIN, 'user-account'),
  signup: () => modalChange(modes.SIGNUP, 'user-account'),
  gotoHp: () => changeURL('/hp'),
  goToResult: (props, source) => replaceURL(`/result${source ? ("?source="+source) : ""}`),
  gotoRoot: () => changeURL('/'),
  getPaymentInfo: (props, data) => getPaymentInfo(data)
}))(OrderPage);



// WEBPACK FOOTER //
// ./src/components/pages/MemberShip/OrderPage/index.js